var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "complainant_info" },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "250px",
          },
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "single-row",
              attrs: { label: "投诉编号：", prop: "complaintNumber" },
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.ruleForm && _vm.ruleForm.complaintCode)),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "double-row",
              attrs: { label: "投诉提交时间：", prop: "objectionTime" },
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.ruleForm && _vm.ruleForm.submitTime)),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "single-row",
              attrs: { label: "被投诉人信息：", prop: "complainedAgainst" },
            },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.ruleForm.complaintAppellees,
                    stripe: "",
                    border: "",
                    "header-cell-style": this.$globalGrayTableHeaderStyle,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: "序号",
                      "header-align": "center",
                      align: "center",
                      width: "50",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      "header-align": "center",
                      label: "主体类别",
                      "min-width": "60",
                      prop: "mainTypeName",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "entName",
                      label: "主体名称",
                      "min-width": "130",
                      "show-overflow-tooltip": true,
                      "header-align": "center",
                      align: "left",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      align: "center",
                      "header-align": "center",
                      label: "主体代码",
                      "min-width": "100",
                      prop: "entCode",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "legalAgentor",
                      label: "法定代表人",
                      "min-width": "80",
                      "header-align": "center",
                      "show-overflow-tooltip": true,
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "address",
                      label: "地址",
                      "header-align": "center",
                      "min-width": "140",
                      "show-overflow-tooltip": true,
                      align: "left",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "120",
                      "header-align": "center",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "text",
                                  size: "small",
                                  title: "查看",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleChastened(scope.row)
                                  },
                                },
                              },
                              [_vm._v("发起联合惩戒")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "single-row",
              attrs: { label: "投诉内容和请求：", prop: "complaintsRequests" },
            },
            [
              _c("el-input", {
                attrs: {
                  disabled: "",
                  type: "textarea",
                  cols: "30",
                  rows: "10",
                },
                model: {
                  value: _vm.ruleForm.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "content", $$v)
                  },
                  expression: "ruleForm.content",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "single-row",
              attrs: { label: "投诉依据与理由：", prop: "complaintGrounds" },
            },
            [
              _c("el-input", {
                attrs: {
                  disabled: "",
                  type: "textarea",
                  cols: "30",
                  rows: "10",
                },
                model: {
                  value: _vm.ruleForm.reason,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "reason", $$v)
                  },
                  expression: "ruleForm.reason",
                },
              }),
            ],
            1
          ),
          _vm._l(_vm.ruleForm.attachments, function (item, index) {
            return _c(
              "el-col",
              { key: index, attrs: { span: 24 } },
              [
                _c("affix-doc", {
                  staticClass: "affixDown",
                  attrs: {
                    item: item,
                    name: item.fileTypeName,
                    labelWidth: "250px",
                  },
                  on: {
                    "update:item": function ($event) {
                      item = $event
                    },
                  },
                }),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }